module.exports = __webpack_public_path__ + "static/the-switch-email-f80c6197e368462623f570cc41dad9b3.jpg";